export enum Language {
  DUTCH = 'nl',
  FRENCH = 'fr'
}
